import React from 'react';

export default function BackupRestore() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Backup & Restore</h1>
      <p className="text-gray-500">Halaman Backup & Restore</p>
    </div>
  );
}
